export const SpeakerData = [
  {
    no: 1,
    id: 'evt120_sp_000',
    name: 'Feras Alshomer',
    affiliation: 'Asan medical center,<br/>King Abdullaziz Medical City',
    country: 'Saudi Arabia',
  },
  // { no: 1, id: 'evt120_sp_000_b', name: 'Benjamin Ascher', affiliation: 'Le centre IENA', country: 'France', noPic: true, noCv: true },
  { no: 1, id: 'evt120_sp_001', name: 'Erin Brown', affiliation: 'British Columbia Univ.', country: 'Canada' },
  { no: 2, id: 'evt120_sp_002_a', name: 'Marlon Buncamper', affiliation: 'Ghent Univ.', country: 'Belgium' },
  { no: 2, id: 'evt120_sp_002', name: 'Ernest Sai-Yun Chiu', affiliation: 'New York University Langone Medical Center ', country: 'USA' },
  // { no: 2, id: 'evt120_sp_002', name: 'Yates Yen-Yu Chao', affiliation: 'CHAO Institute of Aesthetic Medicine', country: 'Taiwan' },
  { no: 3, id: 'evt120_sp_003', name: 'Tae Chong', affiliation: 'Virginia Commonwealth Univ.', country: 'USA' },
  { no: 4, id: 'evt120_sp_004', name: 'Apirag Chuangsuwanich', affiliation: 'Mahidol University Hospital', country: 'Thailand' },
  {
    no: 5,
    id: 'evt120_sp_005',
    name: 'Joseph H. Dayan',
    affiliation: 'Memorial Sloan Kettering Cancer Center',
    country: 'USA',
  },
  { no: 6, id: 'evt120_sp_006', name: 'Ivica Ducic', affiliation: 'Washington Nerve Institute', country: 'USA' },
  { no: 7, id: 'evt120_sp_007', name: 'Mabel Falguera', affiliation: 'Hospital Universitario Reina Sofia', country: 'Spain' },
  { no: 8, id: 'evt120_sp_008', name: 'Keizo Fukuta', affiliation: 'Verite Clinic', country: 'Japan' },
  { no: 9, id: 'evt120_sp_009', name: 'Geoffrey Hallock', affiliation: 'St.Luke&#39;s Univ.', country: 'USA' },
  { no: 9, id: 'evt120_sp_009_1', name: 'Matsumine Hajime', affiliation: 'Tokyo Women’s Medical Univ.', country: 'Japan' },
  { no: 10, id: 'evt120_sp_010', name: 'Akitatsu Hayashi', affiliation: 'Kameda General Hospital', country: 'Japan' },
  { no: 11, id: 'evt120_sp_011', name: 'Susana Heredero', affiliation: 'Hospital Universitario Reina Sofia ', country: 'Spain' },
  { no: 11, id: 'evt120_sp_011_2', name: 'Kusuhara Hirohisa', affiliation: 'Kindai Univ.', country: 'Japan' },
  { no: 12, id: 'evt120_sp_012', name: 'Yen Chang Hsiao', affiliation: 'Chang Gung Memorial Hospital', country: 'Taiwan' },
  { no: 13, id: 'evt120_sp_013', name: 'Atsushi Imaizumi', affiliation: 'Okinawa Prefectural Chubu Hospital', country: 'Japan' },
  { no: 14, id: 'evt120_sp_014', name: 'Marco Innocenti', affiliation: 'Bologna Univ.', country: 'Italy' },
  // { no: 15, id: 'evt120_sp_015', name: 'Jonathan Isaacs', affiliation: 'Virginia Commonwealth Univ.', country: 'USA' },
  { no: 16, id: 'evt120_sp_016', name: 'Shintaro Kagimoto', affiliation: 'Yokohama-City University Hospital', country: 'Japan' },
  { no: 16, id: 'evt120_sp_017', name: 'Lee Seng Khoo', affiliation: 'Skin Check Clinic', country: 'Malaysia' },
  {
    no: 17,
    id: 'evt120_sp_018',
    name: 'Kidakorn Kiranantawat',
    affiliation: 'Ramathibodi Hospital, Mahidol Univ.',
    country: 'Thailand',
    // noCv: true,
  },

  { no: 18, id: 'evt120_sp_019', name: 'Yuzo Komuro', affiliation: 'Teikyo Univ.', country: 'Japan' },
  {
    no: 19,
    id: 'evt120_sp_016_b',
    name: 'Sanguan Kunaporn',
    affiliation: 'Bangkok Hospital Siriroj',
    country: 'Thailand',
  },
  {
    no: 19,
    id: 'evt120_sp_019_b',
    name: 'Wee Leon Lam',
    affiliation: 'Edinburgh Univ.',
    country: 'UK',
    // noPic: true,
    // noCv: true,
  },

  { no: 20, id: 'evt120_sp_020', name: 'Charles K. Lee', affiliation: 'University of California(UCSF)', country: 'USA' },

  { no: 20, id: 'evt120_sp_021_b', name: 'Nabil M. Mansour', affiliation: 'Mansoura Univ.', country: 'Egypt' },
  { no: 21, id: 'evt120_sp_021', name: 'Hiroki Mori', affiliation: 'Tokyo Medical & Dental Univ.', country: 'Japan' },
  {
    no: 22,
    id: 'evt120_sp_022',
    name: 'Emeka F.M. Nkenke',
    affiliation: 'Medical of Vienna Univ.',
    country: 'Austria',
    // noCv: true,
    // noPic: true,
  },
  { no: 23, id: 'evt120_sp_023', name: 'Kunihiko Nohira', affiliation: 'Soshundo Plastic Surgery', country: 'Japan' },
  { no: 24, id: 'evt120_sp_024', name: 'Ziv Peled', affiliation: 'Peled Plastic Surgery', country: 'USA' },
  { no: 25, id: 'evt120_sp_025', name: 'Anne Peled-Warren', affiliation: 'California Pacific Medical Center', country: 'USA' },
  { no: 26, id: 'evt120_sp_026', name: 'Giorgio Pietramaggiori', affiliation: 'Global Medical Institute Lausanne', country: 'Switzerland' },
  { no: 27, id: 'evt120_sp_027', name: 'Luca Piovano', affiliation: 'Chirurgo Plastico Roma', country: 'Italy' },
  {
    no: 28,
    id: 'evt120_sp_028',
    name: 'Vani Prasad',
    affiliation: 'Lymphoedema and Lipoedema Surgery',
    country: 'Austrailia',
    // noCv: true,
    // noPic: true,
  },
  // {
  //   no: 29,
  //   id: 'evt120_sp_029',
  //   name: 'Harikrishna K.Ragavan Nair',
  //   affiliation: 'Hospital Kuala Lumpur',
  //   country: 'Malaysia',
  //   // noCv: true,
  // },
  {
    no: 29,
    id: 'evt120_sp_029',
    name: 'Jeremy Rawlins',
    affiliation: 'Royal Perth Hospital',
    country: 'Australia',
  },
  {
    no: 29,
    id: 'evt120_sp_029_b',
    name: 'Bauback Safa',
    affiliation: 'The Buncke Clinic',
    country: 'USA',
  },
  { no: 30, id: 'evt120_sp_030', name: 'Saja Scherer', affiliation: 'Global Medical Institute', country: 'Switzerland' },
  { no: 31, id: 'evt120_sp_031', name: 'Marcos Sforza', affiliation: 'N1 Plastic Surgery', country: 'UK' },
  { no: 32, id: 'evt120_sp_032', name: 'Yushi Suzuki', affiliation: 'Keio Univ.', country: 'Japan' },
  {
    no: 33,
    id: 'evt120_sp_033',
    name: 'Rieka Taghizadeh',
    affiliation: 'St Helen and Knowsley teaching hospital liverpool U.K.',
    country: 'UK',
    longTerm: true,
    // noCv: true,
    // noPic: true,
  },
  { no: 34, id: 'evt120_sp_034', name: 'Warangkana Noon Tonaree', affiliation: 'Mahidol University Hospital', country: 'Thailand' },
  { no: 34, id: 'evt120_sp_034_b', name: 'Winnie Tong', affiliation: 'Kaiser Permanente Medical Center', country: ' USA' },
  { no: 34, id: 'evt120_sp_034_c', name: 'Abtelfattah Usama', affiliation: 'Al-Azhar University Hospital', country: 'Egypt', noCv: true },
  { no: 35, id: 'evt120_sp_035', name: 'Takumi Yamamoto', affiliation: 'National Center for Global Health and Medicine', country: 'Japan' },
  { no: 36, id: 'evt120_sp_036', name: 'Tomoyuki Yano', affiliation: 'The Cancer Institute Hospital of Jfcr', country: 'Japan' },
  { no: 37, id: 'evt120_sp_037', name: 'Sugawara Yasushi', affiliation: 'Lilla Craniofacial Clinic', country: 'Japan' },
];

export const SpeakerDataKor = [
  { no: 1, name: 'Sang Gue Kang', affiliation: 'Soonchunhyang Univ.', pic: 'Sang Gue Kang', cv: '강상규', noCv: true },
  { no: 2, name: 'Sang Yoon Kang', affiliation: 'Kyung Hee Univ.', pic: 'Sang Yoon Kang', cv: '강상윤', noCv: true },
  { no: 3, name: 'Eun Taek Kang', affiliation: 'Migo Plastic Surgery Clinic', pic: 'Eun Taek Kang', cv: '강은택' },
  { no: 4, name: 'Beomseok Ko', affiliation: 'Univ. of Ulsan', pic: 'Beomseok Ko', cv: '고범석' },
  { no: 5, name: 'Ju Young Go', affiliation: 'Atelier Plastic Surgery', pic: 'Ju Young Go', cv: '고주영' },
  { no: 6, name: 'Han Woong Ko', affiliation: 'Eyebeauty Plastic Surgery Clinic', pic: 'Han Woong Ko', cv: '고한웅' },
  { no: 7, name: 'Min Ho Kwak', affiliation: 'DASIPIUM Plastic Surgery', pic: 'Min Ho Kwak', cv: '곽민호' },
  { no: 8, name: 'Kwang Sik Kook', affiliation: 'IDEA Plastic Surgery Clinic', pic: 'Kwang Sik Kook', cv: '국광식' },
  { no: 9, name: ' Seong Ihl Kwon', affiliation: 'IDEA Plastic Surgery Clinic', pic: ' Seong Ihl Kwon', cv: '권성일', noCv: true },
  { no: 10, name: 'Soon Man Kwon', affiliation: 'Eastman Orthodontic Clinic', pic: 'Soon Man Kwon', cv: '권순만' },
  { no: 11, name: 'Jungwoo Kwon', affiliation: 'YUNO Plastic Surgery Clinic', pic: 'Jungwoo Kwon', cv: '권정우' },
  { no: 12, name: 'Sae Hwi Ki', affiliation: 'Inha Univ.', pic: 'Sae Hwi Ki', cv: '기세휘', noCv: true },
  { no: 13, name: 'Kuylhee Kim', affiliation: 'Hallym Univ.', pic: 'Kuylhee Kim', cv: '김결희', noCv: true },
  { no: 14, name: 'Kwang Seog Kim', affiliation: 'Chonnam National Univ.', pic: 'Kwang Seog Kim', cv: '김광석' },
  { no: 15, name: 'Kook Hyun Kim', affiliation: 'Human Plastic Surgery Clinic', pic: 'Kook Hyun Kim', cv: '김국현' },
  { no: 16, name: 'Ki Tae Kim', affiliation: 'Tae Plastic Surgery Clinic', pic: 'Ki Tae Kim', cv: '김기태' },
  { no: 17, name: 'Deok-Yeol Kim', affiliation: 'CHA Univ.', pic: 'Deok-Yeol Kim', cv: '김덕열', noCv: true },
  { no: 18, name: 'Deok Woo Kim', affiliation: 'Korea Univ.', pic: 'Deok Woo Kim', cv: '김덕우' },
  { no: 19, name: 'Dong Yeon Kim', affiliation: 'The Catholic Univ. of Korea', pic: 'Dong Yeon Kim', cv: '김동연' },
  { no: 20, name: 'Moo Hyun Kim', affiliation: 'JK Imperial Center ', pic: 'Moo Hyun Kim', cv: '김무현' },
  { no: 21, name: 'Min Soo Kim', affiliation: 'Yonsei ENB Plastic Surgery Clinic', pic: 'Min Soo Kim', cv: '김민수' },
  { no: 22, name: 'Minji Kim', affiliation: 'Ajou Univ.', pic: 'Minji Kim', cv: '김민지', noCv: true },
  { no: 23, name: 'Min-Chul Kim', affiliation: 'V Plastic Surgery Clinic', pic: 'Min-Chul Kim', cv: '김민철' },
  { no: 24, name: 'Baek-Kyu Kim', affiliation: 'Seoul National Univ.', pic: 'Baek-Kyu Kim', cv: '김백규', noCv: true },
  { no: 25, name: 'Byung Jun Kim', affiliation: 'Seoul National Univ.', pic: 'Byung Jun Kim', cv: '김병준', noCv: true },
  { no: 26, name: 'Sang Wha Kim', affiliation: 'Seoul National Univ.', pic: 'Sang Wha Kim', cv: '김상화', noCv: true },
  { no: 27, name: 'Suk Wha Kim', affiliation: 'CHA Univ.', pic: 'Suk Wha Kim', cv: '김석화', noCv: true },
  {
    no: 28,
    name: 'Suwon Kim',
    affiliation: 'Secretariat for Advanced Regenerative Medicine and Advanced Biological Products Review Committee',
    pic: 'Suwon Kim',
    cv: '김수원',
  },
  { no: 29, name: 'Seung Chan Kim', affiliation: 'IEUL Plastic Surgery Clinic', pic: 'Seung Chan Kim', cv: '김승찬' },
  { no: 30, name: 'Yeon Jun Kim', affiliation: 'JW Plastic Surgery Center', pic: 'Yeon Jun Kim', cv: '김연준' },
  { no: 31, name: 'Young-Seok Kim', affiliation: 'Yonsei Univ.', pic: 'Young-Seok Kim', cv: '김영석' },
  {
    no: 32,
    name: 'Yong Bae Kim',
    affiliation: 'Yonsei Univ.',
    pic: 'Yong Bae Kim',
    cv: '김용배(방사선)',
  },
  {
    no: 33,
    name: 'Yong Bae Kim',
    affiliation: 'Wonjin Plastic Surgery Clinic',
    pic: 'Yong Bae Kim',
    cv: '김용배(원진 성형외과)',
    noCv: true,
  },
  { no: 34, name: 'Yong Ha Kim', affiliation: 'Yeungnam Univ.', pic: 'Yong Ha Kim', cv: '김용하' },
  { no: 35, name: 'Woo Seob Kim', affiliation: 'Chung-Ang Univ.', pic: 'Woo Seob Kim', cv: '김우섭', noCv: true },
  { no: 36, name: 'Jae Woo Kim', affiliation: 'The Plastic Surgery Clinic', pic: 'Jae Woo Kim', cv: '김재우' },
  { no: 37, name: 'Jae In Kim', affiliation: 'GLOVI Plastic Surgery Clinic', pic: 'Jae In Kim', cv: '김재인' },
  { no: 38, name: 'Jong Seo Kim', affiliation: 'Kim-Jongseo Clinic', pic: 'Jong Seo Kim', cv: '김종서' },
  { no: 39, name: 'Jong-Ho Kim', affiliation: 'Seoul National Univ.', pic: 'Jong-Ho Kim', cv: '김종호' },
  { no: 40, name: 'Joo Hyoung Kim', affiliation: 'Pusan National Univ.', pic: 'Joo Hyoung Kim', cv: '김주형', noCv: true },
  { no: 41, name: 'Jino Kim', affiliation: 'New Hair Plastic Surgery Clinic', pic: 'Jino Kim', cv: '김진오' },
  { no: 42, name: 'Tae Gon Kim', affiliation: 'Yeungnam Univ.', pic: 'Tae Gon Kim', cv: '김태곤', noCv: true },
  { no: 43, name: 'Tae Mo Kim', affiliation: 'V Plastic Surgery Clinic', pic: 'Tae Mo Kim', cv: '김태모' },
  { no: 44, name: 'Taek Kyun Kim', affiliation: 'The Plus Plastic Surgery', pic: 'Taek Kyun Kim', cv: '김택균' },
  { no: 45, name: 'Han Jo Kim', affiliation: 'Eight Aesthetic Plastic Surgical Clinic', pic: 'Han Jo Kim', cv: '김한조', noCv: true },
  { no: 46, name: 'Hyonsurk Kim', affiliation: 'Dankook Univ.', pic: 'Hyonsurk Kim', cv: '김현석' },
  { no: 47, name: 'Hyunsoo Kim', affiliation: 'GRIDA Plastic Surgery Clinic', pic: 'Hyunsoo Kim', cv: '김현수' },
  { no: 48, name: 'Hyung-Gu Kim', affiliation: 'L&C Bio Ltd.', pic: 'Hyung-Gu Kim', cv: '김형구' },
  { no: 49, name: 'Hyung Jun Kim', affiliation: 'Regenerative Medicine Acceleration Foundation', pic: 'Hyung Jun Kim', cv: '김형준' },
  { no: 49, name: 'Hong Seok Kim', affiliation: 'Ohkims K Plastic Surgery Clinic', pic: 'Hong Seok Kim', cv: '김홍석' },
  { no: 50, name: 'Hongil Kim', affiliation: 'Kosin Univ.', pic: 'Hongil Kim', cv: '김홍일' },
  { no: 51, name: 'Hoon Kim', affiliation: 'Konyang Univ.', pic: 'Hoon Kim', cv: '김훈', noCv: true },
  { no: 52, name: 'Youngcheon Na', affiliation: 'Wonkwang Univ.', pic: 'Youngcheon Na', cv: '나영천', noCv: true },
  { no: 53, name: 'Eun Young Rha', affiliation: 'The Catholic Univ. of Korea', pic: 'Eun Young Rha', cv: '나은영' },
  { no: 54, name: 'Sik Namgoong', affiliation: 'Korea Univ.', pic: 'Sik Namgoong', cv: '남궁식' },
  { no: 55, name: 'Si-Gyun Roh', affiliation: 'Chonbuk Univ.', pic: 'Si-Gyun Roh', cv: '노시균', noCv: true },
  { no: 56, name: 'Tai Suk Roh', affiliation: 'Yonsei Univ.', pic: 'Tai Suk Roh', cv: '노태석', noCv: true },
  { no: 57, name: 'Hyung Joo Noh', affiliation: 'Healthpoint Hospital, UAE', pic: 'Hyung Joo Noh', cv: '노형주', noCv: true },
  { no: 58, name: 'GyeongHyeon Doh', affiliation: 'Tami Plastic Surgery Clinic', pic: 'GyeongHyeon Doh', cv: '도경현' },
  { no: 59, name: 'Eon Rok Do', affiliation: '1mm Plastic Surgery Clinic', pic: 'Eon Rok Do', cv: '도언록' },
  { no: 60, name: 'Eun Sang Dhong', affiliation: 'Korea Univ.', pic: 'Eun Sang Dhong', cv: '동은상' },
  { no: 61, name: 'Jeong Yeop Ryu', affiliation: 'Kyungpook National Univ.', pic: 'Jeong Yeop Ryu', cv: '류정엽' },
  { no: 62, name: 'Huijoong Ryu', affiliation: 'The M Plastic Surgery Clinic', pic: 'Huijoong Ryu', cv: '류희중' },
  { no: 63, name: 'Yujin Myung', affiliation: 'Seoul National Univ.', pic: 'Yujin Myung', cv: '명유진' },
  { no: 64, name: 'Jae Seong Moh', affiliation: 'Dr. MOH Plastic Surgery Clinic', pic: 'Jae Seong Moh', cv: '모재성' },
  { no: 65, name: 'Kyung Chul Moon', affiliation: 'Korea Univ.', pic: 'Kyung Chul Moon', cv: '문경철', noCv: true },
  { no: 66, name: 'Goo-Hyun Mun', affiliation: 'Sungkyunkwan Univ.', pic: 'Goo-Hyun Mun', cv: '문구현' },
  { no: 67, name: 'Suk-Ho Moon', affiliation: 'The Catholic Univ. of Korea', pic: 'Suk-Ho Moon', cv: '문석호', noCv: true },
  { no: 68, name: 'Kyunghyun Min', affiliation: 'Hanyang Univ.', pic: 'Kyunghyun Min', cv: '민경현', noCv: true },
  { no: 69, name: 'Jang Hwan Min', affiliation: 'Batang Plastic Surgery Clinic', pic: 'Jang Hwan Min', cv: '민장환', noCv: true },
  { no: 70, name: 'Hyung Jun Min', affiliation: 'LABE Plastic Surgery Clinic', pic: 'Hyung Jun Min', cv: '민형준' },
  { no: 71, name: 'Kyong Hwa Park', affiliation: 'Korea Univ.', pic: 'Kyong Hwa Park', cv: '박경화' },
  { no: 72, name: 'Dong Kwon Park', affiliation: 'Amond Plastic Surgery Clinic', pic: 'Dong Kwon Park', cv: '박동권' },
  { no: 73, name: 'Myong Chul Park', affiliation: 'Hallym Univ.', pic: 'Myong Chul Park', cv: '박명철', noCv: true },
  { no: 74, name: 'Min Suk Park', affiliation: 'The Catholic Univ. of Korea', pic: 'Min Suk Park', cv: '박민석' },
  { no: 75, name: 'Beyoung Yun Park', affiliation: 'CBK Plastic Surgery', pic: 'Beyoung Yun Park', cv: '박병윤', noCv: true },
  { no: 76, name: 'Sang Hyeon Park', affiliation: 'Semi Plastic Surgical Clinic', pic: 'Sang Hyeon Park', cv: '박상현', noCv: true },
  { no: 77, name: 'Seong Oh Park', affiliation: 'Hanyang Univ.', pic: 'Seong Oh Park', cv: '박성오' },
  { no: 78, name: 'Sung-Wan Park', affiliation: 'April31 Plastic Surgery Clinic', pic: 'Sung-Wan Park', cv: '박성완' },
  { no: 79, name: 'Song I Park', affiliation: 'NANA Plastic Surgery Clinic', pic: 'Song I Park', cv: '박송이' },
  { no: 80, name: 'Soo Yeon Park', affiliation: 'Madeyoung Plastic Surgery Clinic', pic: 'Soo Yeon Park', cv: '박수연' },
  { no: 81, name: 'Soo Ho Park', affiliation: 'Mojelim Plastic Surgery Clinic', pic: 'Soo Ho Park', cv: '박수호', noCv: true },
  {
    no: 82,
    name: 'Young Jin Park',
    affiliation: 'Gangnam Samsung Aesthetic Plastic Surgical Clinic',
    pic: 'Young Jin Park',
    cv: '박영진',
    noCv: true,
  },
  { no: 83, name: 'Eun Soo Park', affiliation: 'Soonchunhyang Univ.', pic: 'Eun Soo Park', cv: '박은수' },
  { no: 84, name: 'Jae Woo Park', affiliation: 'BIO Plastic Surgery Clinic', pic: 'Jae Woo Park', cv: '박재우' },
  { no: 84, name: 'Jong Hye Park', affiliation: 'Regenerative Medicine Acceleration Foundation', pic: 'Jong Hye Park', cv: '박종혜' },
  { no: 85, name: 'Joonkyu Park', affiliation: 'SURES Plastic Surgery Clinic', pic: 'Joonkyu Park', cv: '박준규' },
  { no: 86, name: 'Ji Ung Park', affiliation: 'Seoul National Univ.', pic: 'Ji Ung Park', cv: '박지웅' },
  { no: 87, name: 'Chang Sik Pak', affiliation: 'Univ. of Ulsan', pic: 'Chang Sik Pak', cv: '박창식', noCv: true },
  { no: 88, name: 'Chul Park', affiliation: 'BIO Plastic Surgery Clinic', pic: 'Chul Park', cv: '박철' },
  { no: 89, name: 'Tae Hwan Park', affiliation: 'Hallym Univ.', pic: 'Tae Hwan Park', cv: '박태환' },
  { no: 90, name: 'Yong Chan Bae', affiliation: 'Pusan National Univ.', pic: 'Yong Chan Bae', cv: '배용찬' },
  { no: 91, name: 'Joon Ik Bae', affiliation: 'Lawfirm LK', pic: 'Joon Ik Bae', cv: '배준익' },
  { no: 92, name: 'Rong-Min Baek', affiliation: 'Seoul National Univ.', pic: 'Rong-Min Baek', cv: '백롱민', noCv: true },
  { no: 93, name: 'Wooyeol Baek', affiliation: 'Yonsei Univ.', pic: 'Wooyeol Baek', cv: '백우열' },
  { no: 94, name: 'Jin Suk Byun', affiliation: 'Leaders Plastic Surgery Clinic', pic: 'Jin Suk Byun', cv: '변진석' },
  { no: 95, name: 'Man Koon Suh', affiliation: 'JW Plastic Surgery Center', pic: 'Man Koon Suh', cv: '서만군' },
  { no: 96, name: 'Bommie Florence Seo', affiliation: 'The Catholic Univ. of Korea', pic: 'Bommie Florence Seo', cv: '서보미' },
  { no: 97, name: 'Youngchul Suh', affiliation: 'Yonsei Univ.', pic: 'Youngchul Suh', cv: '서영철', noCv: true },
  { no: 98, name: 'Yeui Seok Seo', affiliation: 'Area88 Plastic Surgery', pic: 'Yeui Seok Seo', cv: '서의석' },
  { no: 99, name: 'Hyun Suk Suh', affiliation: 'Univ. of Ulsan', pic: 'Hyun Suk Suh', cv: '서현석', noCv: true },
  { no: 100, name: 'Hyung Joon Seo', affiliation: 'Pusan National Univ.', pic: 'Hyung Joon Seo', cv: '서형준' },
  { no: 101, name: 'Chul Hwan Seul', affiliation: 'JW Plastic Surgery Center', pic: 'Chul Hwan Seul', cv: '설철환', noCv: true },
  {
    no: 102,
    name: 'Nak Kwan Sung',
    affiliation: 'Sung Nak Kwan Aesthetic Plastic Surgery Clinic',
    pic: 'Nak Kwan Sung',
    cv: '성낙관',
    noCv: true,
  },
  { no: 103, name: 'Kyu Sub So', affiliation: 'Bl Plastic Surgery Clinic', pic: 'Kyu Sub So', cv: '소규섭' },
  { no: 104, name: 'Daegu Son', affiliation: 'Keimyung Univ.', pic: 'Daegu Son', cv: '손대구', noCv: true },
  { no: 105, name: 'Yoo Seok Shon', affiliation: 'PLEASURESEOUL Plastic Surgery', pic: 'Yoo Seok Shon', cv: '손유석' },
  { no: 106, name: 'Kyeong Ho Song', affiliation: 'Four Seasons Plastic Surgery Clinic', pic: 'Kyeong Ho Song', cv: '송경호' },
  { no: 107, name: 'Sunho Song', affiliation: 'Divine Plastic Surgery Clinic', pic: 'Sunho Song', cv: '송선호' },
  { no: 108, name: 'Seung Han Song', affiliation: 'Chungnam National Univ.', pic: 'Seung Han Song', cv: '송승한' },
  { no: 109, name: 'Yong Ho Shin', affiliation: 'BIO Plastic Surgery Clinic', pic: 'Yong Ho Shin', cv: '신용호', noCv: true },
  { no: 110, name: 'Jongweon Shin', affiliation: 'The Catholic Univ. of Korea', pic: 'Jongweon Shin', cv: '신종원' },
  { no: 111, name: 'Jin Hee Shim', affiliation: 'S Class Plastic Surgery Clinic', pic: 'Jin Hee Shim', cv: '심진희' },
  {
    no: 112,
    name: 'Ki-Young Ahn',
    affiliation: 'Dr. Ahn Ki Young’s Aesthetic & Plastic Surgical Clinic',
    pic: 'Ki-Young Ahn',
    cv: '안기영',
    noCv: true,
  },
  { no: 113, name: 'Sanghyun Ahn', affiliation: 'Seoul National Univ.', pic: 'Sanghyun Ahn', cv: '안상현' },
  { no: 113, name: 'Tae Joo Ahn', affiliation: 'Sui Plastic Surgery', pic: 'Tae Joo Ahn', cv: '안태주', noCv: true },
  { no: 114, name: 'Hee Chang Ahn', affiliation: 'CHA Univ.', pic: 'Hee Chang Ahn', cv: '안희창', noCv: true },
  { no: 115, name: 'Eun Jung Yang', affiliation: 'Yonsei Univ.', pic: 'Eun Jung Yang', cv: '양은정', noCv: true },
  { no: 116, name: 'Jung Dug Yang', affiliation: 'Kyungpook National Univ.', pic: 'Jung Dug Yang', cv: '양정덕', noCv: true },
  { no: 117, name: 'Gi Hoon Yang', affiliation: 'Baobab Healthcare Inc.', pic: 'Gi Hoon Yang', cv: '양지훈' },
  { no: 118, name: 'Chae Eun Yang', affiliation: 'Yonsei Univ.', pic: 'Chae Eun Yang', cv: '양채은' },
  { no: 119, name: 'Su Rak Eo', affiliation: 'Dongkook Univ.', pic: 'Su Rak Eo', cv: '어수락', noCv: true },
  { no: 120, name: 'Jin Sup Eom', affiliation: 'Univ. of Ulsan', pic: 'Jin Sup Eom', cv: '엄진섭', noCv: true },
  { no: 121, name: 'Deuk Young Oh', affiliation: 'The Catholic Univ. of Korea', pic: 'Deuk Young Oh', cv: '오득영', noCv: true },
  { no: 122, name: 'Tae Suk Oh', affiliation: 'Univ. of Ulsan', pic: 'Tae Suk Oh', cv: '오태석' },
  { no: 123, name: 'Jae Jin Ock', affiliation: 'The Plastic Surgery Clinic', pic: 'Jae Jin Ock', cv: '옥재진', noCv: true },
  { no: 124, name: 'Kyong-Je Woo', affiliation: 'Ewha Womans Univ.', pic: 'Kyong-Je Woo', cv: '우경제', noCv: true },
  { no: 125, name: 'Sang Hyun Woo', affiliation: 'W Hosp.', pic: 'Sang Hyun Woo', cv: '우상현', noCv: true },
  { no: 126, name: 'Kyunghan You', affiliation: 'Geunal Plastic Surgery Clinic', pic: 'Kyunghan You', cv: '유경한' },
  { no: 127, name: 'Dae Hyun Lew', affiliation: 'Yonsei Univ.', pic: 'Dae Hyun Lew', cv: '유대현' },
  { no: 128, name: 'Hansu Yoo', affiliation: 'Liting Plastic Surgery', pic: 'Hansu Yoo', cv: '유한수' },
  { no: 129, name: 'Hwan Yoo', affiliation: 'Harmony Law Firm', pic: 'Hwan Yoo', cv: '유환' },
  { no: 130, name: 'Hijin You', affiliation: 'Korea Univ.', pic: 'Hijin You', cv: '유희진' },
  { no: 131, name: 'Wonyoung Yoon', affiliation: 'Mend Plastic Surgery Clinic', pic: 'Wonyoung Yoon', cv: '윤원영' },
  { no: 132, name: 'Won-June Yoon', affiliation: 'Migo Plastic Surgery Clinic', pic: 'Won-June Yoon', cv: '윤원준', noCv: true },
  { no: 133, name: 'Eul Sik Yoon', affiliation: 'Korea Univ.', pic: 'Eul Sik Yoon', cv: '윤을식', noCv: true },
  { no: 134, name: 'In Sik Yun', affiliation: 'Yonsei Univ.', pic: 'In Sik Yun', cv: '윤인식', noCv: true },
  { no: 135, name: 'Changwoon Yun', affiliation: 'View Plastic Surgery Clinic', pic: 'Changwoon Yun', cv: '윤창운', noCv: true },
  { no: 136, name: 'Seokchan Eun', affiliation: 'Seoul National Univ.', pic: 'Seokchan Eun', cv: '은석찬' },
  { no: 137, name: 'Kang Woo Lee', affiliation: 'Mind Plastic Surgery Clinic', pic: 'Kang Woo Lee', cv: '이강우' },
  { no: 138, name: 'Kyeong-Tae Lee', affiliation: 'Sungkyunkwan Univ.', pic: 'Kyeong-Tae Lee', cv: '이경태' },
  { no: 139, name: 'Da Woon Lee', affiliation: 'Soonchunhyang Univ.', pic: 'Da Woon Lee', cv: '이다운' },
  { no: 140, name: 'Dong Won Lee', affiliation: 'Yonsei Univ.', pic: 'Dong Won Lee', cv: '이동원' },
  { no: 141, name: 'Dong Chul Lee', affiliation: 'Gwangmyeong Sungae General Hosp.', pic: 'Dong Chul Lee', cv: '이동철', noCv: true },
  { no: 142, name: 'Myung Chul Lee', affiliation: 'Konkuk Univ.', pic: 'Myung Chul Lee', cv: '이명철', noCv: true },
  { no: 143, name: 'Sang Woo Lee', affiliation: 'DA Plastic Surgery Clinic', pic: 'Sang Woo Lee', cv: '이상우', noCv: true },
  { no: 144, name: 'So Ki Yi', affiliation: 'Seorae Plastic Surgery Clinic', pic: 'So Ki Yi', cv: '이석기', noCv: true },
  { no: 145, name: 'Seung Ryul Lee', affiliation: 'TIMEPLUS Aesthetic Plastic Surgery', pic: 'Seung Ryul Lee', cv: '이승렬' },
  { no: 146, name: 'Seung Woo Lee', affiliation: 'Gangnam Dr. Woo Plastic Surgery Clinic', pic: 'Seung Woo Lee', cv: '이승우' },
  {
    no: 147,
    name: 'Eojin Yi',
    affiliation: 'Seoul School of Integrated Science and Technology (aSSIST)',
    pic: 'Eojin Yi',
    cv: '이어진',
    noCv: true,
  },
  { no: 148, name: 'Young Dae Lee', affiliation: 'MBW Aesthetic Plastic Surgical Clinic', pic: 'Young Dae Lee', cv: '이영대', noCv: true },
  { no: 149, name: 'Yong Woo Lee', affiliation: 'LIKE Plastic Surgery', pic: 'Yong Woo Lee', cv: '이용우' },
  { no: 150, name: 'Woo Sung Lee', affiliation: 'Rose Plastic Surgery', pic: 'Woo Sung Lee', cv: '이우성' },
  { no: 151, name: 'Won Lee', affiliation: 'Yonsei E1 Plastic Surgery Clinic', pic: 'Won Lee', cv: '이원' },
  { no: 152, name: 'Won Jai Lee', affiliation: 'Yonsei Univ.', pic: 'Won Jai Lee', cv: '이원재', noCv: true },
  { no: 153, name: 'Eun Jung Lee', affiliation: 'YonSei Natural Beauty Aesthetic Surgical Clinic', pic: 'Eun Jung Lee', cv: '이은정' },
  { no: 154, name: 'Jae Woo Lee', affiliation: 'Pusan National Univ.', pic: 'Jae Woo Lee', cv: '이재우', noCv: true },
  { no: 155, name: 'Joo Heon Lee', affiliation: 'Wonjin Plastic Surgery Clinic', pic: 'Joo Heon Lee', cv: '이주헌', noCv: true },
  { no: 156, name: 'Joon Seok Lee', affiliation: 'Kyungpook National Univ.', pic: 'Joon Seok Lee', cv: '이준석' },
  { no: 157, name: 'Jun Wook Lee', affiliation: 'Dite Plastic Surgery', pic: 'Jun Wook Lee', cv: '이준욱', noCv: true },
  { no: 158, name: 'Jung Ho Lee', affiliation: 'The Catholic Univ. of Korea', pic: 'Jung Ho Lee', cv: '이중호', noCv: true },
  { no: 159, name: 'Jin Gyu Lee', affiliation: 'ABLY Plastic Surgery Clinic', pic: 'Jin Gyu Lee', cv: '이진규' },
  { no: 160, name: 'Jin Soo Lee', affiliation: 'Faceline Plastic Surgery Clinic', pic: 'Jin Soo Lee', cv: '이진수' },
  { no: 161, name: 'Tae Yul Lee', affiliation: 'Korea Univ.', pic: 'Tae Yul Lee', cv: '이태열' },
  { no: 162, name: 'Han Jeong Lee', affiliation: 'ATOP Aesthetic Plastic Surgical Clinic', pic: 'Han Jeong Lee', cv: '이한정' },
  { no: 163, name: 'Hyung Chul Lee', affiliation: 'Korea Univ.', pic: 'Hyung Chul Lee', cv: '이형철' },
  { no: 164, name: 'Hong-Ki Lee', affiliation: 'Image Plastic Surgery Clinic', pic: 'Hong-Ki Lee', cv: '이홍기', noCv: true },
  { no: 165, name: 'Seok Kyung In', affiliation: 'Seoul National Univ.', pic: 'Seok Kyung In', cv: '인석경' },
  { no: 166, name: 'Nam Kyu Lim', affiliation: 'Dankook Univ.', pic: 'Nam Kyu Lim', cv: '임남규' },
  { no: 167, name: 'So Young Lim', affiliation: 'Sungkyunkwan Univ.', pic: 'So Young Lim', cv: '임소영' },
  { no: 168, name: 'Jong Woo Lim', affiliation: 'One Percent Plastic Surgery Clinic', pic: 'Jong Woo Lim', cv: '임종우' },
  { no: 169, name: 'Joong Hyuk Yim', affiliation: 'For B Plastic Surgery Clinic', pic: 'Joong Hyuk Yim', cv: '임중혁' },
  { no: 170, name: 'Hyoseob Lim', affiliation: 'Ajou Univ.', pic: 'Hyoseob Lim', cv: '임효섭', noCv: true },
  { no: 171, name: 'Yoon-Jung Chang', affiliation: 'National Cancer Center', pic: 'Yoon-Jung Chang', cv: '장윤정' },
  { no: 172, name: 'Hak Chang', affiliation: 'Seoul National Univ.', pic: 'Hak Chang', cv: '장학' },
  { no: 173, name: 'Daiwon Jun', affiliation: 'The Catholic Univ. of Korea', pic: 'Daiwon Jun', cv: '전대원', noCv: true },
  { no: 174, name: 'Byung-Joon Jeon', affiliation: 'Sungkyunkwan Univ.', pic: 'Byung-Joon Jeon', cv: '전병준' },
  {
    no: 175,
    name: 'Yeo Reum Jeon',
    affiliation: 'National Health Insurance Service Ilsan Hosp.',
    pic: 'Yeo Reum Jeon',
    cv: '전여름',
    noCv: true,
  },
  { no: 175, name: 'Young Woo Cheon', affiliation: 'Gachon Univ.', pic: 'Young Woo Cheon', cv: '전영우', noCv: true },
  { no: 176, name: 'Young-Joon Jun', affiliation: 'The Catholic Univ. of Korea', pic: 'Young-Joon Jun', cv: '전영준', noCv: true },
  { no: 177, name: 'Hong Bae Jeon', affiliation: 'Dankook Univ.', pic: 'Hong Bae Jeon', cv: '전홍배' },
  { no: 178, name: 'Bok Ki Jung', affiliation: 'Yonsei Univ.', pic: 'Bok Ki Jung', cv: '정복기' },
  { no: 179, name: 'Woo Shik Jeong', affiliation: 'Univ. of Ulsan', pic: 'Woo Shik Jeong', cv: '정우식', noCv: true },
  { no: 180, name: 'Woon Hyeok Jeong', affiliation: 'Keimyung Univ.', pic: 'Woon Hyeok Jeong', cv: '정운혁' },
  { no: 181, name: 'Jae-A Jung', affiliation: 'Hanyang Univ.', pic: 'Jae-A Jung', cv: '정재아', noCv: true },
  { no: 182, name: 'Jae Yong Jeong', affiliation: 'The Plus Plastic Surgery', pic: 'Jae Yong Jeong', cv: '정재용' },
  { no: 183, name: 'Jae Ho Jeong', affiliation: 'Korea Univ.', pic: 'Jae Ho Jeong', cv: '정재호(고려대)' },
  { no: 184, name: 'Jae Ho Chung', affiliation: 'Oblige Plastic Surgery Clinic', pic: 'Jae Ho Chung', cv: '정재호(오블리제)' },
  { no: 185, name: 'Jee Hyeok Chung', affiliation: 'Seoul National Univ.', pic: 'Jee Hyeok Chung', cv: '정지혁' },
  { no: 186, name: 'Jinwook Jeong', affiliation: 'View Plastic Surgery Clinic', pic: 'Jinwook Jeong', cv: '정진욱' },
  { no: 187, name: 'Ho Yun Chung', affiliation: 'Kyungpook National Univ.', pic: 'Ho Yun Chung', cv: '정호윤', noCv: true },
  { no: 188, name: ' Hii Sun Jeong', affiliation: 'Yonsei Univ.', pic: ' Hii Sun Jeong', cv: '정희선', noCv: true },
  { no: 189, name: ' Andrew Kihyun Cho', affiliation: 'Seoul National Univ.', pic: ' Andrew Kihyun Cho', cv: '조기현' },
  { no: 190, name: 'Gil Hwan Jo', affiliation: 'MISOU Plastic Surgery Clinic', pic: 'Gil Hwan Jo', cv: '조길환' },
  { no: 191, name: 'Byung Chae Cho', affiliation: 'Kyungpook National Univ.', pic: 'Byung Chae Cho', cv: '조병채', noCv: true },
  { no: 192, name: 'Soo Young Cho', affiliation: 'Cho Cosmetic Clinic', pic: 'Soo Young Cho', cv: '조수영', noCv: true },
  { no: 193, name: 'SiHyun Cho', affiliation: 'Yonsei Univ.', pic: 'SiHyun Cho', cv: '조시현' },
  { no: 194, name: 'In Chang Cho', affiliation: 'BIO Plastic Surgery Clinic', pic: 'In Chang Cho', cv: '조인창' },
  { no: 195, name: 'Jeongmok Cho', affiliation: 'Incline Plastic Surgery Clinic', pic: 'Jeongmok Cho', cv: '조정목' },
  { no: 196, name: 'Tae Hee Jo', affiliation: 'Keimyung Univ.', pic: 'Tae Hee Jo', cv: '조태희' },
  { no: 197, name: 'Ung Sik Jin', affiliation: 'Seoul National Univ.', pic: 'Ung Sik Jin', cv: '진웅식' },
  { no: 198, name: 'Hoon Jin', affiliation: 'IDEA Plastic Surgery Clinic', pic: 'Hoon Jin', cv: '진훈' },
  { no: 199, name: 'Ji-Hoon Cha', affiliation: 'GIO Plastic Surgery Clinic', pic: 'Ji-Hoon Cha', cv: '차지훈' },
  { no: 200, name: 'Han Gyu Cha', affiliation: 'Soonchunhyang Univ.', pic: 'Han Gyu Cha', cv: '차한규' },
  { no: 201, name: 'Kang Young Choi', affiliation: 'Kyungpook National Univ.', pic: 'Kang Young Choi', cv: '최강영' },
  { no: 202, name: 'Dong Il Choi', affiliation: 'Gangnam Seoyon Plastic Surgery', pic: 'Dong Il Choi', cv: '최동일' },
  { no: 203, name: 'Moon Seop Choi', affiliation: 'Graceonyoung Plastic Surgery Clinic', pic: 'Moon Seop Choi', cv: '최문섭', noCv: true },
  { no: 204, name: 'Sangmun Choi', affiliation: 'Ryan Plastic Surgery Clinic', pic: 'Sangmun Choi', cv: '최상문', noCv: true },
  { no: 205, name: 'Yeop Choi', affiliation: 'Choi-Yeop Plastic Surgery Clinic', pic: 'Yeop Choi', cv: '최엽' },
  { no: 206, name: 'Youngwoong Choi', affiliation: 'Inje Univ.', pic: 'Youngwoong Choi', cv: '최영웅', noCv: true },
  { no: 207, name: 'Ikkyun Choi', affiliation: 'Choi Plastic Surgery Clinic', pic: 'Ikkyun Choi', cv: '최익균' },
  { no: 208, name: 'Jaeik Choi', affiliation: 'KAI Plastic Surgery Clinic', pic: 'Jaeik Choi', cv: '최재익' },
  { no: 209, name: 'Jeongho Choi', affiliation: 'Area88 Plastic Surgery', pic: 'Jeongho Choi', cv: '최정호', noCv: true },
  { no: 210, name: 'Jong Woo Choi', affiliation: 'Univ. of Ulsan', pic: 'Jong Woo Choi', cv: '최종우' },
  { no: 211, name: 'Jin Hee Choi', affiliation: 'W Hosp.', pic: 'Jin Hee Choi', cv: '최진희' },
  { no: 212, name: 'Chang Yong Choi', affiliation: 'Soonchunhyang Univ.', pic: 'Chang Yong Choi', cv: '최창용' },
  { no: 213, name: 'Hong Lim Choi', affiliation: 'JW Plastic Surgery Center', pic: 'Hong Lim Choi', cv: '최홍림', noCv: true },
  {
    no: 214,
    name: 'Hee Youn Choi',
    affiliation: 'Dr. Choi s Aesthetic Plastic Surgical Clinic',
    pic: 'Hee Youn Choi',
    cv: '최희윤',
  },
  { no: 215, name: 'Kwan Chul Tark', affiliation: 'Yonsei Univ.', pic: 'Kwan Chul Tark', cv: '탁관철', noCv: true },
  { no: 216, name: 'Woo Hyun Tark', affiliation: 'Tailor Plastic Surgery Clinic', pic: 'Woo Hyun Tark', cv: '탁우현' },
  { no: 217, name: 'Seong Yun Ha', affiliation: 'Well Aesthetic Plastic Surgery Clinic', pic: 'Seong Yun Ha', cv: '하성윤' },
  { no: 218, name: 'Kyu Nam Han', affiliation: '345 Plastic Surgery Clinic', pic: 'Kyu Nam Han', cv: '한규남' },
  { no: 219, name: 'Sang Baek Han', affiliation: 'Seoul Cheil Plastic Surgery Clinic', pic: 'Sang Baek Han', cv: '한상백' },
  { no: 220, name: 'Hyun Ho Han', affiliation: 'Univ. of Ulsan', pic: 'Hyun Ho Han', cv: '한현호' },
  { no: 221, name: 'Ki Weon Ham', affiliation: 'Eight Aesthetic Plastic Surgical Clinic', pic: 'Ki Weon Ham', cv: '함기원' },
  { no: 222, name: 'Chan Yeong Heo', affiliation: 'Seoul National Univ.', pic: 'Chan Yeong Heo', cv: '허찬영', noCv: true },
  { no: 223, name: 'Jung Keun Hyun', affiliation: 'Dankook Univ.', pic: 'Jung Keun Hyun', cv: '현정근' },
  { no: 224, name: 'Ki Yong Hong', affiliation: 'Seoul National Univ.', pic: 'Ki Yong Hong', cv: '홍기용' },
  { no: 225, name: 'Sung Pyo Hong', affiliation: 'BIO Plastic Surgery Clinic', pic: 'Sung Pyo Hong', cv: '홍성표' },
  { no: 226, name: 'Jeong-Geun Hong', affiliation: 'Metro Plastic Surgery Clinic', pic: 'Jeong-Geun Hong', cv: '홍정근' },
  { no: 227, name: 'Jong Won Hong', affiliation: 'Yonsei Univ.', pic: 'Jong Won Hong', cv: '홍종원' },
  { no: 228, name: 'Joon Pio Hong', affiliation: 'Univ. of Ulsan', pic: 'Joon Pio Hong', cv: '홍준표', noCv: true },
  { no: 229, name: 'Kun Hwang', affiliation: 'Inha Univ.', pic: 'Kun Hwang', cv: '황건' },
  { no: 230, name: 'Na Hyun Hwang', affiliation: 'Korea Univ.', pic: 'Na Hyun Hwang', cv: '황나현' },
  { no: 231, name: 'Dong Yeon Hwang', affiliation: 'NANA Plastic Surgery Clinic', pic: 'Dong Yeon Hwang', cv: '황동연' },
  { no: 232, name: 'Jae Ha Hwang', affiliation: 'Chonnam National Univ.', pic: 'Jae Ha Hwang', cv: '황재하', noCv: true },
];
